<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Добавление клиента</template>
        <template v-slot:content>
            <v-form class = 'px-4' v-model = 'valid'>
                <v-text-field v-model = "client.name" label="Название" :rules = "[rules.required]" required></v-text-field>
                <v-text-field v-model = "client.description" label="Описание клиента" :rules = "[rules.required]" required></v-text-field>
                <v-text-field v-model = "client.org" label="Организация" :rules = "[rules.required]"></v-text-field>
            </v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :disabled = '!valid' :loading = 'indicator' block depressed @click = 'addClient'>Добавить</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'ClientCreateDialog',
        props: ['postAction', 'initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                indicator: false,
                client: {},
                valid: false,
                rules: {
                    required: value => !!value || 'Обязательное поле.'
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            }
        },
        methods: {
            addClient() {
                this.indicator = true;
                let requestData = {...{login: this.$store.getters.currentUser.login}, ...this.client}
                this.$http.post(this.$store.getters.endpoint + '/db/clients', requestData, {
                    headers: this.$store.state.restrictedHeaders
                }).then( (r) => {
                    let response = r.body;
                    if (response.result) {
                        this.visibility = false;
                        this.indicator = false;
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'client'
                            },
                            once: false
                        })
                        this.postAction()
                    } else {
                        console.log(response)
                    }
                })
            }
        }
    }
</script>